import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { PATHS } from '../../routes/paths';
import Spinner from '../ui/Spinner';

/** Guards dashboard and onboarding routes. Sends signed-out users to login. */
export default function RequireAuth({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading && !user) {
    return <Spinner label="Checking your session" />;
  }
  if (!user) {
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={PATHS.login} replace state={{ from }} />;
  }
  // Multi-role users (customer who claimed a vendor page) hold roles[];
  // either dashboard is theirs to visit.
  const held = user.roles?.length ? user.roles : [user.role];
  if (role && !held.includes(role)) {
    const destination = user.role === 'vendor'
      ? PATHS.vendorDashboard
      : user.role === 'admin'
        ? '/admin/seed'
        : PATHS.customerDashboard;
    return (
      <Navigate
        to={destination}
        replace />
    );
  }
  return <>{children}</>;
}
